module.exports = __webpack_public_path__ + "img/Liability_Unselected.efd4c45b.svg";